import React, { useState } from 'react';
import PasswordInput from '../forms/PasswordInput';
import Button from '../common/Button';
import Card from '../common/Card';
import { theme } from '../../config/theme';

const PasswordForm = ({ onSubmit, loading }) => {
  const [passwords, setPasswords] = useState({
    current_password: '',
    new_password: '',
    confirm_password: '',
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswords(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const result = await onSubmit(
      passwords.current_password,
      passwords.new_password,
      passwords.confirm_password
    );

    if (result.success) {
      setPasswords({
        current_password: '',
        new_password: '',
        confirm_password: '',
      });
      setErrors({});
    } else if (result.errors) {
      setErrors(result.errors);
    }
  };

  return (
    <Card padding="xl">
      <h2 style={{
        fontSize: theme.typography.fontSize.xl,
        fontWeight: theme.typography.fontWeight.semibold,
        marginBottom: theme.spacing.xl,
      }}>
        Change Password
      </h2>

      <form onSubmit={handleSubmit}>
        <PasswordInput
          label="Current Password"
          name="current_password"
          value={passwords.current_password}
          onChange={handleChange}
          error={errors.current_password}
          required
        />

        <PasswordInput
          label="New Password"
          name="new_password"
          value={passwords.new_password}
          onChange={handleChange}
          error={errors.new_password}
          helperText="Minimum 6 characters"
          required
        />

        <PasswordInput
          label="Confirm New Password"
          name="confirm_password"
          value={passwords.confirm_password}
          onChange={handleChange}
          error={errors.confirm_password}
          required
        />

        <Button type="submit" loading={loading} disabled={loading}>
          Update Password
        </Button>
      </form>
    </Card>
  );
};

export default PasswordForm;